
$(function(){
    console.log('dqwdw')
$(document).on("click",".u_quick_product__btn",function(e) {
  console.log('product atc')
  e.stopPropagation()
  e.preventDefault()
       var vid = $(this).attr('var-id');
       let qty = $(this).attr('var-qty')
  let ths = $(this)
   $.ajax({
url:'/cart/add.js',
type:'post',
dataType:'json',
data:{
        quantity: qty, 
        id: vid
},
    success:function(){
      console.log('addon product addedd successfully');  
 document.dispatchEvent(new CustomEvent('cart:build'));
 $('.cart-link').trigger('click')
    },
       error:function(err){
          console.log("Error",err);
          let res_err = err.responseText;
      let f_err = JSON.parse(res_err)
      console.log('error',f_err)
         }

})         
    });
})